// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__y-wOX","nav__input":"Navbar_nav__input__W2t1z"};